import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  fetchSpecialtiesList,
  editSpecialty,
  updateSpecialty,
  trashSpecialty, reorderSpecialties
} from "../../Adapters/ApiAdapter";
import { baseImage_path, baseUrl } from "../../variables/Variables";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import {
  DndContext, DragOverlay,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import QuillWithHexColor from "../../components/QuillWithHexColor";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CKEditorField from "../../components/CKEditorField";
const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }], // ✅ color support
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    ["clean"],
  ],
};

const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "list",
  "bullet",
  "link",
  "image",
];

const ListSpecialties = () => {
  const [specialties, setSpecialties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editSpecialtyItem, setEditSpecialtyItem] = useState(null);
  const [deleteSpecialtyId, setDeleteSpecialtyId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loadingAction, setLoadingAction] = useState(false);

  const [topSpecialties20, setTopSpecialties20] = useState([]);
  const [remainingSpecialties, setRemainingSpecialties] = useState([]);
  const [activeSpecialty, setActiveSpecialty] = useState(null);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const data = await fetchSpecialtiesList();
  //       setSpecialties([...data.specialities].sort((a, b) => b.id - a.id));
  //     } catch (error) {
  //       toast.error("Failed to fetch specialties.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetchSpecialtiesList();
        const all = res.specialities;

        const top20 = [...all]
          .filter((s) => s.display_order && s.display_order <= 20)
          .sort((a, b) => a.display_order - b.display_order);

        const remaining = all.filter((s) => !top20.some(t => t.id === s.id));

        setTopSpecialties20(top20);
        setRemainingSpecialties(remaining);
      } catch {
        toast.error("Failed to fetch specialties.");
      }
    };

    fetchData();
  }, []);

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, " ")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");
  };

  const cleanQuillHtml = (html) => {
    if (typeof html !== "string") return "";
    return html
      .replace(/<p><br\s*\/?><\/p>/g, "")  // remove empty paragraphs
      .replace(/<p><\/p>/g, "")            // remove other empty <p> tags
      .replace(/<br\s*\/?>/g, "");         // remove <br> if you don’t want them
  };

  const SortableRow = ({ specialty, onEdit, onRemove }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
    } = useSortable({ id: specialty.id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      cursor: "move",
    };

    return (
      <TableRow ref={setNodeRef} style={style} hover>
        <TableCell {...attributes} {...listeners} style={{ cursor: "grab", width: 40 }}>
          <DragIndicatorIcon />
        </TableCell>
        {/* <TableCell {...attributes} {...listeners}>{specialty.id}</TableCell> */}
        <TableCell>{specialty.display_order}</TableCell>
        <TableCell>{specialty.name}</TableCell>
        <TableCell>{stripHtml(specialty.description)}</TableCell>
        <TableCell>
          <img src={`${baseImage_path}/${specialty.img_path}`} alt={specialty.name} width="60" />
        </TableCell>
        <TableCell>
          <Button onClick={() => onEdit(specialty.id)}>Edit</Button>
           {onRemove && (
            <Button color="warning" onClick={() => onRemove(specialty.id)}>Remove</Button>
          )}
        </TableCell>
      </TableRow>
    );
  };

  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragStart = (event) => {
    const activeId = event.active.id;
    const draggedItem =
      topSpecialties20.find(s => s.id === activeId) ||
      remainingSpecialties.find(s => s.id === activeId);

    setActiveSpecialty(draggedItem);
  };

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    setActiveSpecialty(null); // reset overlay

    if (!over || active.id === over.id) return;

    const activeItem = topSpecialties20.find(s => s.id === active.id)
      || remainingSpecialties.find(s => s.id === active.id);
    const overItem = topSpecialties20.find(s => s.id === over.id);

    if (!activeItem || !overItem) return;

    // if (!topSpecialties20.some(s => s.id === active.id)) {
    //   if (topSpecialties20.length >= 20) {
    //     toast.warning("Only 20 specialties allowed");
    //     return;
    //   }

    //   const insertIndex = topSpecialties20.findIndex(s => s.id === over.id);
    //   const updated = [...topSpecialties20];
    //   updated.splice(insertIndex, 0, activeItem);
    //   setTopSpecialties20(updated);
    //   setRemainingSpecialties(prev => prev.filter(s => s.id !== active.id));

    //   await reorderSpecialties({
    //     from_id: activeItem.id || 0,
    //     to_id: overItem.id,
    //   });

    //   toast.success("Specialty added to Top 20 successfully.");

    // } 
    if (!topSpecialties20.some(s => s.id === active.id)) {
      const insertIndex = topSpecialties20.findIndex(s => s.id === over.id);
      let updated = [...topSpecialties20];

      // Insert dragged item
      updated.splice(insertIndex, 0, activeItem);

      // If more than 20, remove the last one and add to All
      if (updated.length > 20) {
        const removed = updated.pop(); // remove last one
        setRemainingSpecialties(prev => [...prev, removed]);
      }

      setTopSpecialties20(updated);
      setRemainingSpecialties(prev => prev.filter(s => s.id !== active.id));

      try {
        await reorderSpecialties({
          from_id: activeItem.id,
          to_id: overItem.id,
        });
        toast.success("Specialty added to Top 20 successfully.");
      } catch (err) {
        toast.error("Failed to update order.");
      }
    }

    else {
      // Reorder inside Top 20
      const oldIndex = topSpecialties20.findIndex(s => s.id === active.id);
      const newIndex = topSpecialties20.findIndex(s => s.id === over.id);
      const reordered = arrayMove(topSpecialties20, oldIndex, newIndex);
      setTopSpecialties20(reordered);

      await reorderSpecialties({
        from_id: activeItem.id,
        to_id: overItem.id,
      });
      toast.success("Specialty reordered successfully.");
    }
  };

  const handleEdit = async (id) => {
    try {
      const response = await editSpecialty(id);
      console.log("Edit Specialty Response:", response); // Debug API response

      if (response && response.data) {
        const specialty = response.data;
        setEditSpecialtyItem({
          id: specialty.id || "",
          name: specialty.name || "",
          description: specialty.description || "",
          slug: specialty.slug || "",
          overview: specialty.overview || "",
          disease: specialty.disease || "",
          treatment: specialty.treatment || "",
          technology: specialty.technology || "",
          procedure: specialty.procedure || "",
          status: specialty.status || "",
          img_file: specialty.img_path || specialty.img_file || "",
          banner_img: specialty.banner_img || "",
          meta_title: specialty.meta_title || "",
          meta_description: specialty.meta_description || "",
          meta_keywords: specialty.meta_keywords || "",
          custom_scripts: specialty.custom_scripts || "",
          og_title: specialty.og_title || "",
          og_description: specialty.og_description || "",
          og_type: specialty.og_type || "",
          og_url: specialty.og_url || "",
          og_image: specialty.og_image || "",
          og_locale: specialty.og_locale || "",
          og_site_name: specialty.og_site_name || "",
          og_image_width: specialty.og_image_width || "",
          og_image_height: specialty.og_image_height || "",
          og_image_type: specialty.og_image_type || "",
          article_modified_time: specialty.article_modified_time || "",
          canonical_link: specialty.canonical_link || "",
          twitter_card: specialty.twitter_card || "",
          twitter_title: specialty.twitter_title || "",
          twitter_description: specialty.twitter_description || "",
          twitter_image: specialty.twitter_image || "",
          twitter_site: specialty.twitter_site || "",
        });

        console.log("State after setting:", {
          id: specialty.id || "",
          name: specialty.name || "",
          description: specialty.description || "",
          img_file: specialty.img_file || "",
        }); // Debugging state
      } else {
        toast.error("Failed to fetch specialty for editing.");
      }
    } catch (error) {
      console.error("Error fetching specialty for edit:", error);
      toast.error("Failed to fetch specialty for editing.");
    }
  };

  const handleSaveEdit = async () => {
    setLoadingAction(true);
    const formData = new FormData();

    formData.append("name", editSpecialtyItem.name);
    formData.append("slug", editSpecialtyItem.slug);
    formData.append("description", cleanQuillHtml(editSpecialtyItem.description));
    formData.append("overview", cleanQuillHtml(editSpecialtyItem.overview));
    formData.append("disease", cleanQuillHtml(editSpecialtyItem.disease));
    formData.append("treatment", cleanQuillHtml(editSpecialtyItem.treatment));
    formData.append("technology", cleanQuillHtml(editSpecialtyItem.technology));
    formData.append("procedure", cleanQuillHtml(editSpecialtyItem.procedure));
    formData.append("status", editSpecialtyItem.status);
    formData.append("video_link", editSpecialtyItem.video_link || "");

    formData.append("meta_title", editSpecialtyItem.meta_title);
    formData.append("meta_description", cleanQuillHtml(editSpecialtyItem.meta_description));
    formData.append("meta_keywords", editSpecialtyItem.meta_keywords);
    formData.append("custom_scripts", editSpecialtyItem.custom_scripts);
    formData.append("og_title", editSpecialtyItem.og_title);
    formData.append("og_description", cleanQuillHtml(editSpecialtyItem.og_description));
    formData.append("og_type", editSpecialtyItem.og_type);
    // formData.append("og_image", editSpecialtyItem.og_image);
    formData.append("og_url", editSpecialtyItem.og_url);
    formData.append("og_locale", editSpecialtyItem.og_locale);
    formData.append("og_site_name", editSpecialtyItem.og_site_name);
    formData.append("og_image_width", editSpecialtyItem.og_image_width);
    formData.append("og_image_height", editSpecialtyItem.og_image_height);
    formData.append("og_image_type", editSpecialtyItem.og_image_type);
    formData.append(
      "article_modified_time",
      editSpecialtyItem.article_modified_time
    );
    formData.append("canonical_link", editSpecialtyItem.canonical_link);
    formData.append("twitter_card", editSpecialtyItem.twitter_card);
    formData.append("twitter_title", editSpecialtyItem.twitter_title);
    formData.append("twitter_description", cleanQuillHtml(editSpecialtyItem.twitter_description));

    formData.append("twitter_site", editSpecialtyItem.twitter_site);

    // Only append img_path if a new image is selected
    if (editSpecialtyItem.img_file instanceof File) {
      formData.append("img_file", editSpecialtyItem.img_file);
    }
    if (editSpecialtyItem.banner_img instanceof File) {
      formData.append("banner_img", editSpecialtyItem.banner_img);
    }
    if (editSpecialtyItem.og_image instanceof File) {
      formData.append("og_image", editSpecialtyItem.og_image);
    }
    if (editSpecialtyItem.twitter_image instanceof File) {
      formData.append("twitter_image", editSpecialtyItem.twitter_image);
    }

    try {
      await updateSpecialty(editSpecialtyItem.id, formData);
      toast.success("Specialty updated successfully!");
      setSpecialties((prev) =>
        prev.map((item) =>
          item.id === editSpecialtyItem.id
            ? {
              ...item,
              name: editSpecialtyItem.name,
              slug: editSpecialtyItem.slug,
              description: editSpecialtyItem.description,
              overview: editSpecialtyItem.overview,
              disease: editSpecialtyItem.disease,
              treatment: editSpecialtyItem.treatment,
              technology: editSpecialtyItem.technology,
              procedure: editSpecialtyItem.procedure,
              status: editSpecialtyItem.status,
              img_file: editSpecialtyItem.img_file,
              banner_img: editSpecialtyItem.banner_img,
              meta_title: editSpecialtyItem.meta_title,
              meta_description: editSpecialtyItem.meta_description,
              meta_keywords: editSpecialtyItem.meta_keywords,
              custom_scripts: editSpecialtyItem.custom_scripts,
              og_title: editSpecialtyItem.og_title,
              og_description: editSpecialtyItem.og_description,
              og_type: editSpecialtyItem.og_type,
              og_url: editSpecialtyItem.og_url,
              og_image: editSpecialtyItem.og_image,
              og_locale: editSpecialtyItem.og_locale,
              og_site_name: editSpecialtyItem.og_site_name,
              og_image_width: editSpecialtyItem.og_image_width,
              og_image_height: editSpecialtyItem.og_image_height,
              og_image_type: editSpecialtyItem.og_image_type,
              article_modified_time: editSpecialtyItem.article_modified_time,
              canonical_link: editSpecialtyItem.canonical_link,
              twitter_card: editSpecialtyItem.twitter_card,
              twitter_title: editSpecialtyItem.twitter_title,
              twitter_description: editSpecialtyItem.twitter_description,
              twitter_image: editSpecialtyItem.twitter_image,
              twitter_site: editSpecialtyItem.twitter_site,
            }
            : item
        )
      );
      setEditSpecialtyItem(null);
    } catch (error) {
      toast.error("Failed to save specialty.");
    } finally {
      setLoadingAction(false);
    }
  };

  const handleDelete = async (id) => {
    setLoadingAction(true);
    try {
      await trashSpecialty(id);
      toast.success("Specialty deleted successfully!");
      setSpecialties((prev) => prev.filter((item) => item.id !== id));
      setDeleteSpecialtyId(null);
    } catch (error) {
      toast.error("Failed to delete specialty.");
    } finally {
      setLoadingAction(false);
    }
  };
  // const stripHtml = (html) => html.replace(/<[^>]+>/g, "").trim();
  const stripHtml = (html) => {
    if (typeof html !== "string") return "";
    return html.replace(/<[^>]+>/g, "").trim();
  };

  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "name", headerName: "Name", width: 200 },
    {
      field: "description",
      headerName: "Description",
      width: 250,
      valueGetter: (params) => stripHtml(params.row.description) || "N/A",
    },
    // { field: "status", headerName: "Status", width: 150 },
    {
      field: "img_path",
      headerName: "Image",
      width: 150,
      renderCell: (params) => (
        <img
          src={`${baseImage_path}/${params.row.img_path}`} // Append the base image path to img_path
          alt={params.row.name}
          style={{ width: "100px", height: "auto", borderRadius: "4px" }} // Style the image
        />
      ),
    },
    // {
    //   field: "link",
    //   headerName: "Profile Link",
    //   width: 250,
    //   renderCell: (params) =>
    //     params.row.link ? (
    //       <a href={params.row.link} target="_blank" rel="noopener noreferrer">
    //         View Link
    //       </a>
    //     ) : (
    //       "No Link"
    //     ),
    // },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <Box>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => handleEdit(params.row.id)}
          >
            Edit
          </Button>
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => setDeleteSpecialtyId(params.row.id)}
            style={{ marginLeft: "8px" }}
          >
            Trash
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Specialties List
      </Typography>
      <TextField
        fullWidth
        margin="normal"
        variant="outlined"
        placeholder="Search by name or description"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: '20px' }}
      />

      {/* {loading ? (
        <CircularProgress />
      ) : (
        <DataGrid
          rows={specialties.filter((item) => {
            const term = searchTerm.toLowerCase();
            return (
              item.name.toLowerCase().includes(term) ||
              (item.description && item.description.toLowerCase().includes(term))
            );
          })}
          columns={columns}
          autoHeight
          getRowHeight={() => "auto"}
          getRowId={(row) => row.id}
        />
      )} */}
      {/* Drag and Drop Table */}
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
        {/* Top 20 Specialties */}
        <Typography variant="h6" mt={2}>Top 20 Specialties</Typography>
        <SortableContext items={topSpecialties20.map(s => s.id)} strategy={verticalListSortingStrategy}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell> </TableCell>
                {/* <TableCell>ID</TableCell> */}
                <TableCell>Display Order</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {topSpecialties20.filter(specialty =>
    specialty.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    stripHtml(specialty.description).toLowerCase().includes(searchTerm.toLowerCase())
  ).map((specialty) => (
                <SortableRow
                  key={specialty.id}
                  specialty={specialty}
                  onEdit={handleEdit}
                  onRemove={(id) => {
                    const removed = topSpecialties20.find(s => s.id === id);
                    setTopSpecialties20(prev => prev.filter(s => s.id !== id));
                    setRemainingSpecialties(prev => [...prev, removed]);
                  }}
                />
              ))}
            </TableBody>
          </Table>
        </SortableContext>

        {/* All Remaining Specialties */}
        <Typography variant="h6" mt={4}>All Specialties</Typography>
        <SortableContext items={remainingSpecialties.map(s => s.id)} strategy={verticalListSortingStrategy}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>ID</TableCell>
                {/* <TableCell>Display Order</TableCell> */}
                <TableCell>Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {remainingSpecialties.filter(specialty =>
    specialty.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    stripHtml(specialty.description).toLowerCase().includes(searchTerm.toLowerCase())
  ).map((specialty) => (
                <SortableRow
                  key={specialty.id}
                  specialty={specialty}
                  onEdit={handleEdit}
	          onRemove={(id) => {
        const updated = remainingSpecialties.filter((s) => s.id !== id);
        setRemainingSpecialties(updated);
        handleDelete(id);
      }}
                />
              ))}
            </TableBody>
          </Table>
          <DragOverlay>
            {activeSpecialty ? (
              <TableRow
                style={{
                  padding: 12,
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
                }}
              >
                <TableCell colSpan={7}>
                  {activeSpecialty.name}
                </TableCell>
              </TableRow>
            ) : null}
          </DragOverlay>

        </SortableContext>
      </DndContext>

      {editSpecialtyItem && (
        <Dialog open onClose={() => setEditSpecialtyItem(null)}>
          <DialogTitle>Edit Specialty</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              margin="normal"
              label="Name"
              value={editSpecialtyItem.name}
              onChange={(e) => {
                const newName = e.target.value;
                setEditSpecialtyItem({
                  ...editSpecialtyItem,
                  name: newName,
                  slug: generateSlug(newName),
                });
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="Slug"
              value={editSpecialtyItem.slug}
              onChange={(e) =>
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  slug: e.target.value,
                }))
              }
            />
            <Typography variant="body1">Description</Typography>
            {/* <ReactQuill
              theme="snow"
              value={editSpecialtyItem.description}
              onChange={(value) =>
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  description: value,
                }))
              }
              style={{ height: "200px", marginBottom: "50px" }}
            /> */}
            <CKEditorField
            value={editSpecialtyItem.description}
            onChange={(data) => setEditSpecialtyItem((prev) => ({ ...prev, description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=speciality`}
          />
            <Typography variant="body1">Overview</Typography>
            {/* <QuillWithHexColor
              id="overview"
              value={editSpecialtyItem.overview}
              onChange={(value) =>
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  overview: value,
                }))
              }
            /> */}
            <CKEditorField
            value={editSpecialtyItem.overview}
            onChange={(data) => setEditSpecialtyItem((prev) => ({ ...prev, overview: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=speciality`}
          />
            <Typography variant="body1">Disease</Typography>
            {/* <QuillWithHexColor
              id="disease"
              value={editSpecialtyItem.disease}
              onChange={(value) =>
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  disease: value,
                }))
              }
            /> */}
            <CKEditorField
            value={editSpecialtyItem.disease}
            onChange={(data) => setEditSpecialtyItem((prev) => ({ ...prev, disease: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=speciality`}
          />
            <Typography variant="body1">Treatment</Typography>
            {/* <QuillWithHexColor
              id="treatment"
              value={editSpecialtyItem.treatment}
              onChange={(value) =>
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  treatment: value,
                }))
              }
            /> */}
            <CKEditorField
            value={editSpecialtyItem.treatment}
            onChange={(data) => setEditSpecialtyItem((prev) => ({ ...prev, treatment: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=speciality`}
          />
            <Typography variant="body1">Technology</Typography>
            {/* <QuillWithHexColor
              id="technology"
              value={editSpecialtyItem.technology}
              onChange={(value) =>
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  technology: value,
                }))
              }
            /> */}
            <CKEditorField
            value={editSpecialtyItem.technology}
            onChange={(data) => setEditSpecialtyItem((prev) => ({ ...prev, technology: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=speciality`}
          />
            <Typography variant="body1">Procedure</Typography>
            {/* <QuillWithHexColor
              id="procedure"
              value={editSpecialtyItem.procedure}
              onChange={(value) =>
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  procedure: value,
                }))
              }
            /> */}
            <CKEditorField
            value={editSpecialtyItem.procedure}
            onChange={(data) => setEditSpecialtyItem((prev) => ({ ...prev, procedure: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=speciality`}
          />

            <TextField
              fullWidth
              margin="normal"
              label="Video Link"
              value={editSpecialtyItem.video_link || ""}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  video_link: e.target.value,
                }));
              }}
            />

            {/* <TextField
              fullWidth
              margin="normal"
              label="Status"
              value={editSpecialtyItem.status}
              onChange={(e) =>
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  status: e.target.value,
                }))
              }
            /> */}
            <TextField
              fullWidth
              margin="normal"
              label="Meta Title"
              value={editSpecialtyItem.meta_title}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  meta_title: e.target.value,
                }));
              }}
            />
            <Typography variant="body1" mt={2}>
              Meta Description
            </Typography>
            {/* <ReactQuill
              theme="snow"
              value={editSpecialtyItem.meta_description}
              onChange={(value) =>
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  meta_description: value,
                }))
              }
              style={{ height: "200px", marginBottom: "50px" }}
            /> */}
            <CKEditorField
            value={editSpecialtyItem.meta_description}
            onChange={(data) => setEditSpecialtyItem((prev) => ({ ...prev, meta_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=speciality`}
          />
            <TextField
              fullWidth
              margin="normal"
              label="Meta Keywords"
              value={editSpecialtyItem.meta_keywords}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  meta_keywords: e.target.value,
                }));
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="Custom Scripts"
              value={editSpecialtyItem.custom_scripts}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  custom_scripts: e.target.value,
                }));
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="OG Title"
              value={editSpecialtyItem.og_title}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  og_title: e.target.value,
                }));
              }}
            />

            <Typography variant="body1" mt={2}>
              OG Description
            </Typography>
            {/* <ReactQuill
              theme="snow"
              value={editSpecialtyItem.og_description}
              onChange={(value) =>
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  og_description: value,
                }))
              }
              style={{ height: "200px", marginBottom: "50px" }}
            /> */}

            <CKEditorField
            value={editSpecialtyItem.og_description}
            onChange={(data) => setEditSpecialtyItem((prev) => ({ ...prev, og_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=speciality`}
          />
            <TextField
              fullWidth
              margin="normal"
              label="OG Type"
              value={editSpecialtyItem.og_type}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  og_type: e.target.value,
                }));
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="OG URL"
              value={editSpecialtyItem.og_url}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  og_url: e.target.value,
                }));
              }}
            />

            <TextField
              fullWidth
              margin="normal"
              label="OG Locale"
              value={editSpecialtyItem.og_locale}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  og_locale: e.target.value,
                }));
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="OG Site Name"
              value={editSpecialtyItem.og_site_name}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  og_site_name: e.target.value,
                }));
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="OG Image Width"
              value={editSpecialtyItem.og_image_width}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  og_image_width: e.target.value,
                }));
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="OG Image Height"
              value={editSpecialtyItem.og_image_height}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  og_image_height: e.target.value,
                }));
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="OG Image Type"
              value={editSpecialtyItem.og_image_type}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  og_image_type: e.target.value,
                }));
              }}
            />
            <Typography variant="body1">Article Modified Time</Typography>
            <TextField
              fullWidth
              margin="normal"
              type="datetime-local"
              // label="Article Modified Time"
              value={editSpecialtyItem.article_modified_time}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  article_modified_time: e.target.value,
                }));
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="Canonical Link"
              value={editSpecialtyItem.canonical_link}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  canonical_link: e.target.value,
                }));
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="Twitter Card"
              value={editSpecialtyItem.twitter_card}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  twitter_card: e.target.value,
                }));
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="Twitter Title"
              value={editSpecialtyItem.twitter_title}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  twitter_title: e.target.value,
                }));
              }}
            />
            <Typography variant="body1" mt={2}>
              Twitter Description
            </Typography>
            {/* <ReactQuill
              theme="snow"
              value={editSpecialtyItem.twitter_description}
              onChange={(value) =>
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  twitter_description: value,
                }))
              }
              style={{ height: "200px", marginBottom: "50px" }}
            /> */}
            <CKEditorField
            value={editSpecialtyItem.twitter_description}
            onChange={(data) => setEditSpecialtyItem((prev) => ({ ...prev, twitter_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=speciality`}
          />
            <TextField
              fullWidth
              margin="normal"
              label="Twitter Site"
              value={editSpecialtyItem.twitter_site}
              onChange={(e) => {
                setEditSpecialtyItem((prev) => ({
                  ...prev,
                  twitter_site: e.target.value,
                }));
              }}
            />

            <Typography variant="body1" mt={2} mb={2}>
              Meta_Img
            </Typography>
            {editSpecialtyItem.og_image && (
              <Box mt={2} mb={2} textAlign="center">
                <img
                  src={`${baseImage_path}/${editSpecialtyItem.og_image}`}
                  alt="Specialty"
                  style={{
                    width: "150px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </Box>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                setEditSpecialtyItem({
                  ...editSpecialtyItem,
                  og_image:
                    e.target.files.length > 0
                      ? e.target.files[0]
                      : editSpecialtyItem.og_image,
                });
              }}
            />

            {/* Show Existing Image */}
            <Typography variant="body1" mt={2}>
              Speciality_Img
            </Typography>
            {editSpecialtyItem.img_file && (
              <Box mt={2} mb={2} textAlign="center">
                <img
                  src={
                    editSpecialtyItem.img_file instanceof File
                      ? URL.createObjectURL(editSpecialtyItem.img_file)
                      : `${baseImage_path}/${editSpecialtyItem.img_file}`
                  }
                  alt="Specialty"
                  style={{
                    width: "150px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </Box>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setEditSpecialtyItem({
                  ...editSpecialtyItem,
                  img_file:
                    e.target.files.length > 0
                      ? e.target.files[0]
                      : editSpecialtyItem.img_file,
                })
              }
            />
            <Typography variant="body1" mt={2}>
              Banner_Img
            </Typography>
            {editSpecialtyItem.banner_img && (
              <Box mt={6} mb={2} textAlign="center">
                <img
                  src={
                    editSpecialtyItem.banner_img instanceof File
                      ? URL.createObjectURL(editSpecialtyItem.banner_img)
                      : `${baseImage_path}/${editSpecialtyItem.banner_img}`
                  }
                  alt="Banner"
                  style={{
                    width: "150px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />

              </Box>
            )}
            {/* Upload New Image */}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                setEditSpecialtyItem({
                  ...editSpecialtyItem,
                  banner_img:
                    e.target.files.length > 0
                      ? e.target.files[0]
                      : editSpecialtyItem.banner_img,
                });
              }}
            />

            <Typography variant="body1" mt={2}>
              Twitter Image
            </Typography>
            {editSpecialtyItem.twitter_image && (
              <Box mt={2} mb={2} textAlign="center">
                <img
                  src={`${baseImage_path}/${editSpecialtyItem.twitter_image}`}
                  alt="Specialty"
                  style={{
                    width: "150px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </Box>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                setEditSpecialtyItem({
                  ...editSpecialtyItem,
                  twitter_image:
                    e.target.files.length > 0
                      ? e.target.files[0]
                      : editSpecialtyItem.twitter_image,
                });
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => setEditSpecialtyItem(null)}
              style={{ fontWeight: "bold", backgroundColor: "grey" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveEdit}
              disabled={loadingAction}
            >
              {loadingAction ? <CircularProgress size={24} /> : "Save"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {deleteSpecialtyId && (
        <Dialog open onClose={() => setDeleteSpecialtyId(null)}>
          <DialogTitle>Delete Confirmation</DialogTitle>
          <DialogContent>
            Are you sure you want to delete this specialty?
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setDeleteSpecialtyId(null)}
              variant="outlined"
              style={{ fontWeight: "bold", backgroundColor: "grey" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => handleDelete(deleteSpecialtyId)}
              disabled={loadingAction}
            >
              {loadingAction ? <CircularProgress size={24} /> : "Confirm"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default ListSpecialties;
